import { createStore } from 'vuex'
import createMultiTabState from 'vuex-multi-tab-state';
import api from '../tools/api';


export default createStore({
  state: {
    page: {
     mainTitle: 'Innopearl Partner+',
     subTitle: ''
   },
   innotoken: '',
   refresh_token : "",
   notification: 0,
   isAuth: false,
   role: "",
   fullname : "",
   myProjects:[],
   myLinksPlus: [],
   customerlogo: '',
   affinityConfig:null,
   uid: null,
   loginFrom:null,
   droit_access_platform:null,
   pearlAICredit: 0,
   rankAICredit: 0,
   growthAIToken: 0,
   dataroomSize: 0,
   subscriptionStatus: null,
  },

  getters: {
    affinityConfig: (store) => store.affinityConfig,
     authenticated: (store) => store.isAuth,
     role: (store) => store.role,
     fullname: (store) => store.fullname,
     customerlogo: (store) => store.customerlogo,
     myProjects: (store) => store.myProjects,
     myLinksPlus: (store) => store.myLinksPlus,
      loginFrom: (store) => store?.loginFrom,
      uid: (store) => store.uid,
      droit_access_platform: (store) => store.droit_access_platform,
      pearlAICredit: (store) => store.pearlAICredit,
      rankAICredit: (store) => store.rankAICredit,
      growthAIToken: (store) => store.growthAIToken,
      dataroomSize: (store) => store.dataroomSize,
      subscriptionStatus: (store) => store.subscriptionStatus,
      isPastDue: (store) => store.subscriptionStatus === 'past_due',
      featureLocks: (store) => {
        const dap = store.droit_access_platform;
        const role = store.role;
        if (dap === "pearlai") return { discover: false, scout: true, assess: true, shortcuts: true };
        if (dap === "scouting") return { discover: true, scout: false, assess: true, shortcuts: false };
        if (dap === "pearlai_and_scouting") return { discover: false, scout: false, assess: true, shortcuts: true };
        if (role === "Admin" || role === "Expert") return { discover: false, scout: true, assess: false, shortcuts: true };
        return { discover: false, scout: false, assess: false, shortcuts: false };
      }
  },
  mutations: {
    UPDATE_PAGE_INFO(state, page){
      state.page = page;
    },
    SET_SUBSCRIPTION_STATUS(state, status){
      state.subscriptionStatus = status;
    },
    UPDATE_ROLE(state, role){
      console.log("mutation");
      state.role = role;
         console.log(localStorage.getItem('innorole'));
       localStorage.setItem('innorole', role);
       console.log(localStorage.getItem('innorole'));
    },
    UPDATE_MYPROJECTS(state, project){
      state.myProjects = project;
    },
    UPDATE_MYLINKPLUS(state,project){
      state.myLinksPlus = project
    },
    UPDATE_PROJECTS(state, project){
      var objIndex = state.myProjects.findIndex((obj => obj._id.$oid == project._id.$oid));
      if(objIndex != -1){
          state.myProjects[objIndex] = project;
      }
      else{
          state.myProjects.push(project);
      }
    },
    UPDATE_LINKSPLUS(state, project){
      var objIndex = state.myLinksPlus.findIndex((obj => obj._id.$oid == project._id.$oid));
      if(objIndex != -1){
          state.myLinksPlus[objIndex] = project;
      }
      else{
          state.myLinksPlus.push(project);
      }
    },
    UPDATE_PROJECTS_REMOVE(state, project){
      var objIndex = state.myProjects.findIndex((obj => obj._id.$oid == project._id.$oid));
      if(objIndex != -1){
          state.myProjects.splice(objIndex, 1);
      }
    },
    UPDATE_LINKPLUS_REMOVE(state, project){
      var objIndex = state.myLinksPlus.findIndex((obj => obj._id.$oid == project));
      if(objIndex != -1){
          state.myLinksPlus.splice(objIndex, 1);
      }
    },
    UPDATE_NOTIFICATION(state,amount){
      console.log(amount);
      api.get(process.env.VUE_APP_API_URL+"/restrict/projects_tasks").then( (r) => {
        state.notification = (r.data) ? r.data.required : 0;
      }).catch( (e) => console.log(e));
    },
    UPDATE_DROIT_ACCESS_PLATFORM(state,valdroit){
      state.droit_access_platform = valdroit;
      localStorage.setItem("droit_access_platform",String(state.droit_access_platform));
    },
    UPDATE_PEARLAI_CREDIT(state, amount) {
      state.pearlAICredit = Number(amount) || 0;
      localStorage.setItem('pearlAICredit', String(state.pearlAICredit));
    },
    UPDATE_RANKAI_CREDIT(state, amount) {
      state.rankAICredit = Number(amount) || 0;
      localStorage.setItem('rankAICredit', String(state.rankAICredit));
    },
    UPDATE_GROWTH_TOKEN(state, amount) {
      state.growthAIToken = Number(amount) || 0;
      localStorage.setItem('growthAIToken', String(state.growthAIToken));
    },
    UPDATE_DATAROOM_SIZE(state, size) {
      state.dataroomSize = Number(size) || 0;
    },
    LOGOSET (state,logoData) {
      if(logoData.$oid){
        state.customerlogo = logoData.$oid;
        localStorage.setItem('innologo', logoData.$oid);
      }
    },
    LOGIN (state,loginData) {
      console.log("loginData",loginData);
         state.innotoken = loginData.token.token;
         state.refresh_token = loginData.token.refresh_token;
         state.isAuth = true;
         state.role = loginData.role;
         state.fullname = loginData.fullname;
         state.uid = loginData.uid;
         state.affinityConfig = loginData.affinityConfig;
         state.loginFrom = loginData?.loginFrom;
         state.droit_access_platform = loginData.droit_access_platform ?? "full";
         state.pearlAICredit = Number(loginData.PearlAICredit ?? loginData.pearlAICredit ?? 0) || 0;
         state.rankAICredit = Number(loginData.RankAICredit ?? loginData.rankAICredit ?? loginData.RankAICredit ?? loginData.rankAICredit ?? 0) || 0;
         state.growthAIToken = Number(loginData.GrowthAIToken ?? loginData.growthAIToken ?? 0) || 0;


         if(loginData.logo){
           state.customerlogo = loginData.logo.$oid;
           localStorage.setItem('innologo', loginData.logo.$oid);
         }
         else{
            state.customerlogo = null;
            localStorage.setItem('innologo', null);
         }
         localStorage.setItem("affinityConfig",JSON.stringify(loginData.affinityConfig));
         localStorage.setItem('innotoken', loginData.token.token);
         localStorage.setItem('refresh_token', loginData.token.refresh_token);
         localStorage.setItem('innorole', loginData.role);
              localStorage.setItem('innoname', loginData.fullname);
            localStorage.setItem('loginFrom', loginData?.loginFrom);
              localStorage.setItem('innouid', loginData.uid.$oid);
              localStorage.setItem('innoemail', loginData.email || '');
              localStorage.setItem("droit_access_platform",loginData.droit_access_platform);
              localStorage.setItem('pearlAICredit', String(state.pearlAICredit));
              localStorage.setItem('rankAICredit', String(state.rankAICredit));
              localStorage.setItem('growthAIToken', String(state.growthAIToken));
         api.get(process.env.VUE_APP_API_URL+"/restrict/growth_engine_tokens").then( (r) => {
           state.growthAIToken = Number(r.data && r.data.GrowthAIToken) || 0;
           localStorage.setItem('growthAIToken', String(state.growthAIToken));
         }).catch( (e) => console.log(e));
         api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
           state.myProjects = r.data;
           console.log("myProjects",r);
         }).catch( (e) => console.log(e));
         api.get(process.env.VUE_APP_API_URL+"/restrict/list_mylinkplus").then( (r) => {
           state.myLinksPlus = r.data;
           console.log("myLinksPlus",r);
         }).catch( (e) => console.log(e));
         api.get(process.env.VUE_APP_API_URL+"/restrict/projects_tasks").then( (r) => {
           state.notification = (r.data) ? r.data.required : 0;
         }).catch( (e) => console.log(e));
         api.get(process.env.VUE_APP_API_URL+"/restrict/get_my_dataroom").then( (r) => {
           const market = (r.data && r.data.makert_and_business_intelligence_files) || [];
           const priorities = (r.data && r.data.priorities_and_goals_files) || [];
           state.dataroomSize = market.length + priorities.length;
         }).catch( (e) => console.log(e));
    },
    LOGOUT(state){
         state.refresh_token ="";
         state.innotoken ="";
         state.isAuth = false;
         state.role = "";
          state.fullname = "";
         state.notification = 0;
         state.customerlogo = null;
         state.uid = null;
         state.loginFrom = null;
         state.affinityConfig = null;
         state.droit_access_platform = null;
         state.pearlAICredit = 0;
         state.rankAICredit = 0;
         state.growthAIToken = 0;
         state.dataroomSize = 0;
         localStorage.removeItem("affinityConfig");
         localStorage.removeItem('refresh_token');
         localStorage.removeItem('innotoken');
         localStorage.removeItem('innouid');
         localStorage.removeItem('innoemail');
         localStorage.removeItem('innorole');
         localStorage.removeItem('loginFrom');
         localStorage.removeItem('innologo');
         localStorage.removeItem('currentBasicFilterSet');
         localStorage.removeItem('currentFilterSet');
         localStorage.removeItem('droit_access_platform');
         localStorage.removeItem('pearlAICredit');
         localStorage.removeItem('rankAICredit');
         localStorage.removeItem('growthAIToken');
         state.project = [];
    },
    INITIALISESTORE(state) {
         if(localStorage.getItem('innotoken')){
           state.innotoken = localStorage.getItem('innotoken');
           state.refresh_token = localStorage.getItem('refresh_token');
           state.role = localStorage.getItem('innorole');
            state.customerlogo = localStorage.getItem('innologo');
              state.fullname = localStorage.getItem('innoname');
              state.uid = localStorage.getItem('innouid');
                state.loginFrom = localStorage.getItem('loginFrom');
              state.affinityConfig = localStorage.getItem("affinityConfig");
              state.droit_access_platform = localStorage.getItem("droit_access_platform");
              state.pearlAICredit = Number(localStorage.getItem('pearlAICredit')) || 0;
              state.rankAICredit = Number(localStorage.getItem('rankAICredit')) || 0;
              state.growthAIToken = Number(localStorage.getItem('growthAIToken')) || 0;
           state.isAuth = true;
           api.get(process.env.VUE_APP_API_URL+"/restrict/growth_engine_tokens").then( (r) => {
             state.growthAIToken = Number(r.data && r.data.GrowthAIToken) || 0;
             localStorage.setItem('growthAIToken', String(state.growthAIToken));
           }).catch( (e) => console.log(e));
           api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
             state.myProjects = r.data;
             console.log(r.data);
             console.log(r);
           }).catch( (e) => console.log(e));

           api.get(process.env.VUE_APP_API_URL+"/restrict/list_mylinkplus").then( (r) => {
             state.myLinksPlus = r.data;
             console.log("myLinksPlus",r);
           }).catch( (e) => console.log(e));


           api.get(process.env.VUE_APP_API_URL+"/restrict/projects_tasks").then( (r) => {
             state.notification = (r.data) ? r.data.required : 0;
           }).catch( (e) => console.log(e));

           api.get(process.env.VUE_APP_API_URL+"/restrict/get_my_dataroom").then( (r) => {
             const market = (r.data && r.data.makert_and_business_intelligence_files) || [];
             const priorities = (r.data && r.data.priorities_and_goals_files) || [];
             state.dataroomSize = market.length + priorities.length;
           }).catch( (e) => console.log(e));
          }
      }
  },
  actions: {
    // Fetch the current user's Stripe subscription status (active|past_due|canceled|…)
    fetchSubscriptionStatus({ commit }) {
      return api.get(process.env.VUE_APP_API_URL + "/restrict/stripe/subscription-status")
        .then((r) => {
          commit('SET_SUBSCRIPTION_STATUS', (r.data && r.data.status) || null);
          return r.data;
        })
        .catch(() => { /* silent — no subscription / not reachable */ });
    },
    updateRole(context, page){
      console.log("action");
      context.commit('UPDATE_ROLE',page);
    },
    updateProjects(context, pro){
      console.log("updateProjects");
      context.commit('UPDATE_MYPROJECTS',pro);
    },
    updateLinkplus(context, pro){
      console.log("updateProjects");
      context.commit('UPDATE_MYLINKPLUS',pro);
    },
    updatePage(context, page){
      context.commit('UPDATE_PAGE_INFO',page);
    },
    // Refresh the Growth AI token balance (after a consumption or a grant) so the
    // TopBar / account "AI credits left" stay in sync.
    fetchGrowthTokens({ commit }) {
      return api.get(process.env.VUE_APP_API_URL+"/restrict/growth_engine_tokens").then((r) => {
        commit('UPDATE_GROWTH_TOKEN', (r.data && r.data.GrowthAIToken) || 0);
        return r.data;
      }).catch((e) => {
        console.log(e);
      });
    },
    fetchDataroom({ commit }) {
      return api.get(process.env.VUE_APP_API_URL+"/restrict/get_my_dataroom").then((r) => {
        const market = (r.data && r.data.makert_and_business_intelligence_files) || [];
        const priorities = (r.data && r.data.priorities_and_goals_files) || [];
        commit('UPDATE_DATAROOM_SIZE', market.length + priorities.length);
        return r.data;
      }).catch((e) => {
        console.log(e);
      });
    },
    updateNotification({ commit }, payload) {
      return new Promise((resolve) => {
        // Effectuer les opérations nécessaires pour mettre à jour la notification
        // ...

        // Déclencher la mutation pour mettre à jour le store
        commit('UPDATE_NOTIFICATION', payload);
        resolve();
      });
    }
  },
  modules: {
  },
  plugins: [
    createMultiTabState(),
  ],
})
